export type PrimaryOnlyTenant =
  | { state: "none" }
  | { state: "ready"; tenantId: string }
  | { state: "loading" }
  | { state: "unavailable" }
  | { state: "outside" };

/**
 * Whether a page whose API reaches only the primary cell may act on
 * `tenantId`. With one cell it always may. With several, only once the
 * primary cell's tenant list has loaded and contains the tenant: acting on
 * any other id could write that tenant's data into the primary cell.
 */
export function primaryOnlyTenant({
  cellCount,
  tenantId,
  primaryTenants,
  primaryTenantsLoading,
}: {
  cellCount: number;
  tenantId: string | undefined;
  primaryTenants: { id: string }[] | undefined;
  primaryTenantsLoading: boolean;
}): PrimaryOnlyTenant {
  if (!tenantId) {
    return { state: "none" };
  }
  if (cellCount === 1) {
    return { state: "ready", tenantId };
  }
  if (primaryTenantsLoading) {
    return { state: "loading" };
  }
  if (!primaryTenants) {
    return { state: "unavailable" };
  }
  return primaryTenants.some(({ id }) => id === tenantId)
    ? { state: "ready", tenantId }
    : { state: "outside" };
}
